var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 36,
    viewBox: "0 0 50 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3446 1.13585C49.4743 2.05947 49.5761 3.65053 48.5719 4.6896L19.3789 34.8962C18.8595 35.4336 18.1151 35.7411 17.3334 35.7411C16.5516 35.7411 15.8072 35.4336 15.2878 34.8962L0.69133 19.7929C-0.312866 18.7538 -0.211109 17.1628 0.918612 16.2392C2.04833 15.3156 3.77821 15.4091 4.78241 16.4482L17.3334 29.435L44.4808 1.3449C45.485 0.305832 47.2149 0.21224 48.3446 1.13585Z",
    fill: "#0E8750"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/Checked.189a8e0af40c799dd0232e9910b76b95.svg";
export { ForwardRef as ReactComponent };